export default __webpack_public_path__ + "static/media/19_simon_johnson.d4171ede.jpg";